import React, { PureComponent } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import cs from 'classnames';
import { Box } from '@mui/material';

class TechnicalWorksError extends PureComponent {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  render() {
    return (
      <Box className="app-wrapper" sx={{ width: '100%' }}>
        <div
          className={cs([
            'app-wrapper',
            'page-error-container',
            'animated',
            'slideInUpTiny',
            'animation-duration-3',
          ])}
        >
          <div className="page-error-content">
            <Box className="error-code animated zoomInDown" sx={{ mb: 3 }}>
              502
            </Box>
            <Box
              component="h2"
              className="fw-regular title bounceIn animation-delay-10 animated"
              sx={{ textAlign: 'center' }}
            >
              <p>{this.props.intl.formatMessage({ id: 'extraPages.502Msg' })}</p>
              <p>{this.props.intl.formatMessage({ id: 'extraPages.502Msg.tryLater' })}</p>
            </Box>
          </div>
        </div>
      </Box>
    );
  }
}

export default injectIntl(TechnicalWorksError);
